/**
 * GridLayout.tsx - Grid Layout for SectionNav
 * 
 * CHANGE HISTORY:
 * - 251115_1808 [current] danielbeer: Created grid layout
 */

import React from 'react';
import type { SectionLayoutProps } from '../types';

export const GridLayout: React.FC<SectionLayoutProps> = ({
  sections,
  activeSection,
  onSectionClick
}) => {
  return (
    <div className="section-nav-grid">
      {sections.map((section) => (
        <button
          key={section.id}
          className={`section-grid-item ${activeSection === section.id ? 'section-grid-item--active' : ''} ${section.disabled ? 'section-grid-item--disabled' : ''}`}
          onClick={() => !section.disabled && onSectionClick(section)}
          disabled={section.disabled}
          aria-label={section.label}
          aria-pressed={activeSection === section.id}
        >
          {section.icon && (
            <div className="section-grid-item__icon" aria-hidden="true">
              {section.icon}
            </div>
          )}
          
          <h4 className="section-grid-item__label">{section.label}</h4>
          
          {section.badge && (
            <span className="section-grid-item__badge" aria-label={`${section.badge} notifications`}>
              {section.badge}
            </span>
          )}
        </button>
      ))}
    </div>
  );
};

GridLayout.displayName = 'GridLayout';
